export * from './DetalhesDoProjeto'